'use strict';

import dispatcher from '../dispatcher';
import store from './popup.store';

let items = {};


let html;
let body;
let overlay;

let active = false;


function _handleChange() {
  let storeData = store.getData();

  let ww1 = html.clientWidth;
  let ww2;
  let diff = 0;

  overlay = document.querySelector('.overlay');

  if (active === storeData.active) return;

  if (active) {
    if (items[active]) {
      items[active].element.classList.remove('active');
    }
    if (items[active] && items[active].inner) {
      items[active].inner.style.paddingRight = '';
    }
  } else {
    if (overlay) overlay.classList.add('active');
    html.classList.add('prevent-scroll');

    ww2 = html.clientWidth;
    diff = ww2 - ww1;
    if (diff < 0) diff = 0;
  }

  active = storeData.active;

  if (active) {
    if (items[active]) {
      items[active].element.classList.add('active');
    }
    if (items[active] && items[active].inner) {
      items[active].inner.style.paddingRight = diff + 'px';
    }

    html.style.marginRight = diff + 'px';
  } else {
    if (overlay) overlay.classList.remove('active');
    html.classList.remove('prevent-scroll');

    html.style.marginRight = '';
  }

}

function _add(el) {
  let id = el.id || el.dataset.id;

  if (!id) {
    console.warn('popup id is missing');
    return;
  }

  if (el.classList.contains('active')) {
    active = id;
  }

  items[id] = {
    element: el,
    id: id,
    inner: el.querySelector('.popup-inner')
  };
}

function _handleMutate() {
  let elements = document.querySelectorAll('.popup');


  for (let i = 0; elements.length > i; i++) {
    check(elements[i])
  }
  for (let id in items) {
    if (items.hasOwnProperty(id)) backCheck(id);
  }

  function check(el) {
    for (let id in items) {
      if (items.hasOwnProperty(id) && items[id].element === el) return;
    }
    _add(el);
  }

  function backCheck(id) {
    for (let i = 0; elements.length > i; i++) {
      if (items[id].element === elements[i]) return;
    }
    delete items[id];
  }
}



function init() {
  html = document.documentElement;
  body = document.body;

  _handleMutate();
  _handleChange();

  dispatcher.subscribe(function (e) {
    if (e.type === 'mutate') {
      _handleMutate();
      _handleChange();
    }
  });

  store.eventEmitter.subscribe(function () {
    _handleChange();
  });
}

export default {
  init: init
}